import type { ReactNode } from 'react';

import { LanguageSwitcher } from './LanguageSwitcher';
import { Logo } from './Logo';

interface AppShellProps {
  children: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  return (
    <div className="app-shell">
      <div className="brand-accent" aria-hidden="true" />
      <header className="app-header">
        <Logo />
        <LanguageSwitcher />
      </header>
      <main className="app-main">{children}</main>
      <footer className="app-footer">
        <span>© {new Date().getFullYear()} Credisa AG</span>
      </footer>
    </div>
  );
}
